<app-filter-card (onApply)="filterCardData$.next($event)"></app-filter-card>

<mat-card appearance="outlined">
  <mat-card-content class="p-0">
    <app-datatable
      [configurationInput]="datatableConfigurations"
      [rowData]="formattedDatatableRows()"
      [columns]="datatableColumns"
      [total]="store.dataTotal$()"
      [customColumnDef]="[
        { name: 'name', template: nameCell, isSortable: true },
        { name: 'isActive', template: isActiveCell, isSortable: true },
      ]"
      (deleteClick)="selectedDatatableItems().length >= 2 ? initializeBulkDelete() : initializeDelete()"
      (editClick)="initializeEdit()"
      (dataRefreshRequest)="datatableParams$.next($event)"
      (selectedItemsChange)="selectedDatatableItems.set($event)"
    />
  </mat-card-content>
</mat-card>

<ng-template #nameCell let-row="row">
  <div class="white-space-nowrap">
    {{ row.name }}
    <mat-chip *ngIf="row.isAdmin" class="chip-hover-remove" [disableRipple]="true">
      {{ 'field.admin' | translate | uppercase }}</mat-chip
    >
  </div>
</ng-template>

<ng-template #isActiveCell let-row="row">
  <mat-chip [ngClass]="row.isActive ? 'green' : 'red'" class="chip-hover-remove" [disableRipple]="true">
    {{ (row.isActive ? 'button.active' : 'button.inactive') | translate | uppercase }}
  </mat-chip>
</ng-template>

<ng-template #addEditFormDialog>
  <h1 mat-dialog-title>
    {{ addEditModalTitle() }}
  </h1>
  <form [formGroup]="addEditForm" (ngSubmit)="onFormDialogSubmit()" #form="ngForm">
    <div mat-dialog-content>
      <div class="row">
        <mat-form-field appearance="outline" *ngIf="!isBulkEdit()">
          <mat-label>{{ 'field.name' | translate }}</mat-label>
          <input matInput formControlName="name" />
          <mat-error [control]="addEditForm.get('name')"></mat-error>
        </mat-form-field>
        <div class="bulk-dialog-field mb-2">
          <mat-checkbox
            *ngIf="isBulkEdit()"
            (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isAdmin'))"
          >
          </mat-checkbox>
          <div class="d-flex align-items-center">
            <mat-checkbox formControlName="isAdmin">
              {{ 'field.isAdmin' | translate }}
            </mat-checkbox>
            <mat-icon
              #tooltip="matTooltip"
              [matTooltip]="'page.users.label.adminTooltip' | translate"
              matTooltipPosition="right"
              (click)="tooltip.toggle()"
              >info
            </mat-icon>
          </div>
        </div>
        @if (currentUser.isSuperAdmin) {
          <div class="bulk-dialog-field mb-2">
            <mat-checkbox
              *ngIf="isBulkEdit()"
              (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isSuperAdmin'))"
            >
            </mat-checkbox>
            <div class="d-flex align-items-center">
              <mat-checkbox formControlName="isSuperAdmin">
                {{ 'field.isSuperAdmin' | translate }}
              </mat-checkbox>
              <mat-icon
                #tooltip="matTooltip"
                [matTooltip]="'page.users.label.superAdminTooltip' | translate"
                matTooltipPosition="right"
                (click)="tooltip.toggle()"
                >info
              </mat-icon>
            </div>
          </div>
        }
        <div class="bulk-dialog-field">
          <mat-checkbox
            *ngIf="isBulkEdit()"
            (change)="formService.toggleBulkCheckbox($event, addEditForm.get('isActive'))"
          >
          </mat-checkbox>
          <mat-checkbox formControlName="isActive">
            {{ 'field.active' | translate }}
          </mat-checkbox>
        </div>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ addEditSubmitButtonText() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-template>
